import { LogLevel } from 'angular-auth-oidc-client';

/**
 * @license
 * Copyright Akveo. All Rights Reserved.
 * Licensed under the MIT License. See License.txt in the project root for license information.
 */
export const environment = {
  production: true,

  oidcServer: 'https://auth.efs-ag.services/api',
  userMgmtApi: 'https://api.efs-ag.services/v2',
  landingpageApi: 'https://start.efs-ag.de/v1',
  sophosApi: 'https://devices.efs-ag.com/v1',
  wikiApi: 'https://wiki.efs-ag.services/v1',
  dataDiscoveryApi: 'https://dds.efs-ag.services/v1',
  birthdaymailerApi: 'https://birthday-mailer.efs-ag.services/v1',
  videoServeUrl: 'https://wiki.efs-ag.services',

  openIdConfig: {
    authority: 'https://auth.efs-ag.services',
    redirectUrl: window.location.origin,
    postLogoutRedirectUri: 'https://manage.efs-ag.services',
    postLoginRoute: '/',
    clientId: 'efs.adminpanel',
    scope: 'openid email profile IdentityServerApi accountservice offline_access',
    responseType: 'code',
    historyCleanupOff: false,
    logLevel: LogLevel.Error,
    silentRenew: true,
    useRefreshToken: true,
    renewTimeBeforeTokenExpiresInSeconds: 300,
    forbiddenRoute: '/unauthorized',
    unauthorizedRoute: '/unauthorized',
  },
};
